





































































































































import { defineComponent, reactive, toRefs, computed, ref, onMounted, onBeforeUnmount, watch } from '@vue/composition-api';
import * as Common from "../../commons/common"
import http from "../../plugins/http";
import SaitenEditTab from "../../components/SaitenEditTab.vue";
import DropArea from "../../components/DropArea.vue";
import AlertArea from "../../components/AlertArea.vue";
import { BModal } from 'bootstrap-vue';
import { QuestionImageDiscription } from "../../modules/teacher/QuestionImageUpload"
// @ts-ignore
import VueDragResize from "vue-drag-resize";

export interface Data {
  tabNo: number,
  base_sheet_id: string,
  baseSheet: any,
  pageItems: any[],
  currentPage: number,
  errors: any[],
  scale: number,
  rotates: number[],
  questionImageDiscriptions: QuestionImageDiscription[]
  currentDiscription: QuestionImageDiscription
  isNewDiscription: boolean
  iconSize: number
  isDragging: boolean
}

export default defineComponent({
  components: {
    "saiten-edit-tab": SaitenEditTab,
    "drop-area": DropArea,
    "alert-area": AlertArea,
    "vue-drag-resize": VueDragResize,
  },
  setup(props, context){

    const modalDiscriptionRef = ref<InstanceType<typeof BModal>>();

    /******************************
     * data
     ******************************/
    const state = reactive<Data>({
      tabNo: 6,
      base_sheet_id: "",
      baseSheet: null,
      pageItems: [],
      currentPage: 1,
      errors: [],
      scale: 0.5,
      rotates: [0, 90, 180, 270],
      questionImageDiscriptions: [],
      currentDiscription: null,
      isNewDiscription: false,
      iconSize: 50,
      isDragging: false,
    });

    /******************************
     * 表示中の画像情報
     ******************************/

    const currentPageItem = computed(() => {
      return state.pageItems[state.currentPage - 1];
    });

    /******************************
     * imgタグのスタイル
     ******************************/

    const imageStyle = computed(() => {
      let style: any = {};
      style["width"] = `${currentPageItem.value.baseWidth * state.scale}px`;
      style["height"] = `${currentPageItem.value.baseHeight * state.scale}px`;
      return style;
    });

    /******************************
     * imgの親divのスタイル
     ******************************/

    const imageWrapStyle = computed(() => {
      const style: any = {};
      style["height"] = `${(currentPageItem.value.baseHeight * state.scale) + 30}px`;
      return style;
    });

    /******************************
     * 拡大ボタン押下
     ******************************/

    const scaleUp = () => {
      state.scale += 0.05;
    }

    /******************************
     * 縮小ボタン押下
     ******************************/

    const scaleDown = () => {
      if(state.scale > 0.1){
        state.scale -= 0.05;
      }
    }

    /******************************
     * 左回転ボタン押下
     ******************************/
    
    const rotateLeft = async () => {
      var angle = 0;
      var rotateIdx = state.rotates.indexOf(currentPageItem.value.angle);
      if(rotateIdx == 0){
        angle = 270;
      }else{
        angle = currentPageItem.value.angle - 90;
      }
      currentPageItem.value.angle = angle;

      await rotateSave(false, false);
    }

    /******************************
     * 右回転ボタン押下
     ******************************/
    
    const rotateRight = async () => {
      var angle = 0;
      var rotateIdx = state.rotates.indexOf(currentPageItem.value.angle);
      if(rotateIdx == 3){
        angle = 0;
      }else{
        angle = currentPageItem.value.angle + 90;
      }
      currentPageItem.value.angle = angle;

      await rotateSave(false, false);
    }

    /******************************
     * 回転確定ボタン押下
     ******************************/
    
    const rotateSave = async (isConfirmMsg = true, isResutMsg = true) => {
      
      if(currentPageItem.value.angle == 0){
        alert("回転情報は変更されていません。");
        return;
      }
      
      if(isConfirmMsg && !window.confirm(`${state.currentPage}ページ目の回転状態を保存します。よろしいですか？`)){
        return;
      }

      context.root.$store.dispatch("showOverlay");

      await http.post(`/api/teacher/question_image_upload/rotate/${state.base_sheet_id}`, {angle: currentPageItem.value.angle, page: state.currentPage}).then(response => {
        if (isResutMsg) {
          alert("処理が完了しました。");
        }
        currentPageItem.value.base64Image = response.data.base64_image;
        currentPageItem.value.baseWidth = response.data.image_size_hash.width;
        currentPageItem.value.baseHeight = response.data.image_size_hash.height;
        currentPageItem.value.angle = 0;
      })
      .catch(error=>{
        if(error.response.status == 422){
          state.errors = error.response.data.errors;
        }else{
          state.errors = ["予期せぬ例外が発生しました。"];
        }
      });

      context.root.$store.dispatch("hideOverlay");
    }

    /******************************
     * 答案アップロード
     ******************************/

    const upload = async (files: any) => {
      const extension = Common.getFileExtension(files[0].name);
      if(extension == "jpg"){
        await uploadJpg(files);
      }else if(extension == "zip"){
        await uploadZip(files);
      }else if(extension == "pdf"){
        await uploadPdf(files);
      }
    }

    /******************************
     * アップロード（jpgドラッグ）
     ******************************/

    const uploadJpg = async (files: any[]) => {

      if(!window.confirm("ファイルをアップロードします。よろしいですか？")){
        return;
      }

      context.root.$store.dispatch("showOverlay");

      const config = {
        headers: {'content-type': 'multipart/form-data'}
      }

      let fd = new FormData();
      fd.append("file_count", `${files.length}`);

      for(let i = 0; i < files.length; i++){
        fd.append(`${i}`, files[i]);
      }

      await http.post(`/api/teacher/question_image_upload/upload_jpg/${state.base_sheet_id}`, fd, config).then((response) => {
        alert("アップロードが完了しました。");
        window.location.reload();
      })
      .catch(error=>{
        if(error.response.status == 422){
          state.errors = error.response.data.errors;
        }else{
          state.errors = ["予期せぬ例外が発生しました。"];
        }
      });

      context.root.$store.dispatch("hideOverlay");
    }

    /******************************
     * アップロード（Zipドラッグ）
     ******************************/
    
    const uploadZip = async (files: any) => {

      let fd = new FormData();
      fd.append('upload[file]', files[0]);

      if(!window.confirm("ファイルをアップロードします。よろしいですか？")){
        return;
      }

      context.root.$store.dispatch("showOverlay");

      await http.post(`/api/teacher/question_image_upload/upload_zip/${state.base_sheet_id}`, fd).then(response => {
        alert("アップロードが完了しました。");
        window.location.reload();
      })
      .catch(error=>{
        if(error.response.status == 422){
          state.errors = error.response.data.errors;
        }else{
          state.errors = ["予期せぬ例外が発生しました。"];
        }
      });

      context.root.$store.dispatch("hideOverlay");
    }

    /******************************
     * アップロード（PDFドラッグ）
     ******************************/
    
    const uploadPdf = async (files: any) => {

      let fd = new FormData();
      fd.append('upload[file]', files[0]);

      if(!window.confirm("ファイルをアップロードします。よろしいですか？")){
        return;
      }

      context.root.$store.dispatch("showOverlay");

      await http.post(`/api/teacher/question_image_upload/upload_pdf/${state.base_sheet_id}`, fd).then(response => {
        alert("アップロードが完了しました。");
        window.location.reload();
      })
      .catch(error=>{
        if(error.response.status == 422){
          state.errors = error.response.data.errors;
        }else{
          state.errors = ["予期せぬ例外が発生しました。"];
        }
      });

      context.root.$store.dispatch("hideOverlay");
    }

    /******************************
     * 画像削除
     ******************************/

    const deleteImage = async () => {

      if(!window.confirm("問題用紙を削除します。よろしいですか？")){
        return;
      }

      context.root.$store.dispatch("showOverlay");

      await http.delete(`/api/teacher/question_image_upload/${state.base_sheet_id}`).then(response => {
        alert("処理が完了しました。");
        window.location.reload();
      })
      .catch(error=>{
        if(error.response.status == 422){
          state.errors = error.response.data.errors;
        }else{
          state.errors = ["予期せぬ例外が発生しました。"];
        }
      });

      context.root.$store.dispatch("hideOverlay");

    }

    /******************************
     * 講評文の登録へボタン押下
     ******************************/
    
    const toAutoReviewTemplateEdit = () => {
      context.root.$router.push(`/teacher_site/auto_review_template_edit/${state.base_sheet_id}`).catch(err => {});
    }

    const adjustHeight = () => {
      const winH = window.innerHeight;
      const imageArea = document.getElementById("image-area");

      if(imageArea != null){
        imageArea.style.height = (winH - imageArea.offsetTop) + "px";
      }
    };

    /******************************
     * 初期表示データ設定
     ******************************/

    const initData = (response: any) => {
      
      context.root.$store.commit("setScoringSettingSheetType", response.data.base_sheet.sheet_type);
      state.baseSheet = response.data.base_sheet;
      var pageItems = [];
      for(var i = 0; i < response.data.base64_images.length; i++){
        var pageItem = {
          base64Image: response.data.base64_images[i],
          baseWidth: response.data.image_size_hashes[i].width,
          baseHeight: response.data.image_size_hashes[i].height,
          angle: 0,
        }
        pageItems.push(pageItem);
      }
      state.currentPage = 1;
      state.pageItems = pageItems;

      state.questionImageDiscriptions = response.data.question_image_discriptions.map((x: any)=> new QuestionImageDiscription(x));
    }

    /******************************
     * mounted
     ******************************/
    
    onMounted(async () => {
      context.root.$store.commit("setIsHeaderDisp", false);

      context.root.$store.dispatch("showOverlay", "データ取得中... しばらくお待ちください。");
      state.base_sheet_id = context.root.$route.params.base_sheet_id;

      // APIで登録済みレポート情報・模範解答画像取得
      await http.get(`/api/teacher/question_image_upload?base_sheet_id=${state.base_sheet_id}`).then(response => {
        initData(response);
      })
      .catch(error=>{
        // 後続処理不能のため一覧に戻る
        if(error.response.status == 422){
          alert(`レポート情報の取得処理に失敗しました。一覧に戻ります。\n${error.response.data.errors[0]}`);
        }else{
          alert(`レポート情報の取得処理に失敗しました。一覧に戻ります。`);
        }
        context.root.$store.dispatch("goBaseSheetList");
      });

      adjustHeight();
      window.addEventListener("resize", adjustHeight);

      context.root.$store.dispatch("hideOverlay");
    });

    /******************************
     * Before Unmount
     ******************************/

    onBeforeUnmount(async () => {
      context.root.$store.commit("setIsHeaderDisp", true);
      window.removeEventListener("resize", adjustHeight);
    });

    /******************************
     * 表示中のページに紐づくリンク
     ******************************/

     const pageDiscriptions = computed(() => {
      return state.questionImageDiscriptions.filter(x => x.page == state.currentPage);
    });

    /******************************
     * モーダル表示
     ******************************/

    const showDiscriptionModal = (discription: QuestionImageDiscription) => {
      
      if(discription == null){
        discription = new QuestionImageDiscription(null);
        discription.page = state.currentPage;
        state.isNewDiscription = true;
      }else{
        state.isNewDiscription = false;
      }
      state.currentDiscription = discription;
      state.questionImageDiscriptions.forEach(x => x.is_show_popover = false);
      modalDiscriptionRef.value.show();
    }

    /******************************
     * リンク追加
     ******************************/

    const addNewDiscription = () => {
      if((state.currentDiscription.discription_text == null || state.currentDiscription.discription_text == "") && (state.currentDiscription.link_url == null || state.currentDiscription.link_url == "")){
        alert("説明文、リンクどちらか入力してください。");
        return;
      }

      state.currentDiscription.x = 100;
      state.currentDiscription.y = 100;
      state.questionImageDiscriptions.push(state.currentDiscription);

      Common.showToast(context.root.$bvToast, "用紙の左上に追加しました。");
      modalDiscriptionRef.value.hide();
    }

    /************************************************************
     * リンクアイコンクリック
     ************************************************************/

    const discriptionClick = (discription: QuestionImageDiscription, e: any) => {
      e.stopPropagation();
      state.currentDiscription = discription;
      state.questionImageDiscriptions.forEach(x => x.is_show_popover = false);
      state.currentDiscription.is_show_popover = true;
    }

    /****************************************
     * 画像エリアpointerdown
     ****************************************/

    const imageAreaPointerDown = (e: PointerEvent) => {
      state.currentDiscription = null;
      state.questionImageDiscriptions.forEach(x => x.is_show_popover = false);
    }

    /****************************************
     * アイコンドラッグ中
     ****************************************/

    const dragging = () => {
      state.isDragging = true;
    }

    /****************************************
     * アイコンドラッグ終了
     ****************************************/

    const dragstop = (questionImageDiscription: QuestionImageDiscription, rect: any) => {
      state.isDragging = false;
      state.currentDiscription.is_show_popover = true;
      questionImageDiscription.x = rect.left / state.scale;
      questionImageDiscription.y = rect.top / state.scale;
    }

    /****************************************
     * リンクドラッグ監視
     ****************************************/

    watch(() => state.isDragging, (newVal, oldVal) => {
      if(newVal){
        state.questionImageDiscriptions.forEach(x => x.is_show_popover = false);
      }
    });

    /****************************************
     * リンク削除
     ****************************************/

    const deleteDiscription = (discription: QuestionImageDiscription) => {
      if(!window.confirm("ファイルをアップロードします。よろしいですか？")){
        return;
      }
      const idx = state.questionImageDiscriptions.indexOf(discription);
      state.questionImageDiscriptions.splice(idx, 1);
    }

    /****************************************
     * リンク保存
     ****************************************/

    const saveDiscription = async () => {
      if(!window.confirm("リンク情報を保存します。よろしいですか？")){
        return;
      }

      state.errors = [];

      context.root.$store.dispatch("showOverlay");

      await http.post(`/api/teacher/question_image_upload/save_discription/${state.base_sheet_id}`, {question_image_discriptions: state.questionImageDiscriptions}).then(response => {
        alert("処理が完了しました。");
      })
      .catch(error=>{
        if(error.response.status == 422){
          state.errors = error.response.data.errors;
        }else{
          state.errors = ["予期せぬ例外が発生しました。"];
        }
      });

      context.root.$store.dispatch("hideOverlay");
    }

    return {
      ...toRefs(state),
      modalDiscriptionRef,
      currentPageItem,
      imageStyle,
      imageWrapStyle,
      scaleUp,
      scaleDown,
      rotateLeft,
      rotateRight,
      rotateSave,
      upload,
      toAutoReviewTemplateEdit,
      deleteImage,
      pageDiscriptions,
      showDiscriptionModal,
      addNewDiscription,
      discriptionClick,
      imageAreaPointerDown,
      dragging,
      dragstop,
      deleteDiscription,
      saveDiscription,
    }
  }
})
